"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const npi = {
    name: 'npi',
    tableType: 'dim',
    idField: 'npi',
    grain: [
        '::id',
        '::key',
    ],
    joins: [
        'zip-geo::key',
    ],
    tableGrain: ['!npi'],
    foreignKeys: ['zip-geo::key'],
};
const taxonomy = {
    name: 'taxonomy',
    tableType: 'dim',
    idField: 'taxonomy_code',
    grain: [
        '::id',
        '::key',
    ],
    tableGrain: ['!taxonomy'],
    foreignKeys: [],
};
const vendor = {
    name: 'vendor',
    tableType: 'dim',
    idField: 'vendor_id',
    grain: [
        '::id',
        '::key',
    ],
    tableGrain: ['!vendor'],
    foreignKeys: [],
};
exports.default = [
    npi,
    taxonomy,
    vendor,
];
